import { type Clinic, getClinic } from '@snootsvet/shared'

import { useUserMetadata } from '@/frontend/hooks/use-user-metadata'

/** Resolved user settings with DB-backed values fully hydrated. */
export interface UserSettings {
  defaultClinic: Clinic | null
}

/**
 * Resolved user settings — resolves DB-backed metadata (e.g. clinic IDs)
 * into full objects. Returns `undefined` while metadata is still loading.
 */
export function useUserSettings(): { settings: UserSettings | undefined } {
  const { settings: metadata } = useUserMetadata()

  if (!metadata) return { settings: undefined }

  const preferred = metadata.defaultClinicId ? (getClinic(metadata.defaultClinicId) ?? null) : null

  return {
    settings: {
      defaultClinic: preferred,
    },
  }
}
